import axios from 'axios';
import { getIsApiPending } from '../../../selectors/travelUg/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/travelUg/payloadCollection';
import { setCustomerIdValue } from '../../../actions/travelUg/quote';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import {
    getAlternatePremiumCalculation,
    getCountries,
    getPremiumCalculation,
    getQuoteForm,
} from '../../../selectors/travelUg/quote';
import { getAgentForm } from '../../../selectors/travelUg/travelAgentModal';

export const submitQuoteService = async (store, next, action) => {
    if (getIsApiPending(store.getState())) {
        return next(action);
    }

    store.dispatch(apiTransitionPayloadCollection.pending());

    try {
        const resp = await makeSubmission(store.getState());

        if (resp?.data) {
            store.dispatch(setCustomerIdValue(resp.data.id));
        }
    } catch (error) {
        console.error(error);
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const UGANDA_COUNTRY_ID = 36;

const getSingleCountryId = (country, countries) => {
    if (country === 'Uganda') return UGANDA_COUNTRY_ID;

    const selectedCountry = countries.find(({ name }) => name === country);
    return selectedCountry?.id || null;
};

const getCountryId = (country, countries) => {
    const resolveId = (name) => {
        if (name === 'Uganda') return UGANDA_COUNTRY_ID;
        const match = countries.find(({ name: n }) => n === name);
        return match?.id || null;
    };

    if (typeof country === 'string') {
        return [resolveId(country)];
    }

    if (Array.isArray(country)) {
        return country.map(resolveId);
    }

    return [];
};

const determineUserTotalPremium = (premiumCalc, alternatePremiumCalc, selectedCover) => {
    if (typeof selectedCover.value !== 'string') return 0;
    return selectedCover.value.includes('Elite')
        ? alternatePremiumCalc.value?.totalPremium || 0
        : premiumCalc.value?.totalPremium || 0;
};

const getUserQuoteIdentification = (premiumCalc, alternatePremiumCalc, selectedCover) => {
    if (typeof selectedCover.value !== 'string') return '[]';
    return JSON.stringify(
        selectedCover.value.includes('Elite')
            ? alternatePremiumCalc.value?.quote_id || []
            : premiumCalc.value?.quote_id || []
    );
};

const getFullName = (person) => {
    const firstName = person.firstName?.value || '';
    const middleName = person.middleName?.value || '';
    const lastName = person.lastName?.value || '';

    return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const premiumCalc = getPremiumCalculation(state);
    const alternatePremiumCalc = getAlternatePremiumCalculation(state);
    const countries = getCountries(state);

    return {
        fullName: getFullName(quotation),
        email: quotation.email.value || 'N/A',
        phoneNumber: quotation.phoneNumber.value || 'N/A',
        totalPremium: determineUserTotalPremium(premiumCalc, alternatePremiumCalc, quotation.selectedCover),
        quoteIdentification: getUserQuoteIdentification(premiumCalc, alternatePremiumCalc, quotation.selectedCover),
        quoteCode: '',
        coverType: quotation.selectedCover.value,
        tripType: quotation.tripType.value,
        coverageType: quotation.coverFor.value,
        referredByAgent: !!agent.name?.value,
        agentCode: agent.agentCode?.value ?? 'N/A',
        agentName:
            agent.intermediaryType?.value === 'BANCASSURANCE'
                ? agent.name?.value ?? 'N/A'
                : agent.intermediaryType?.value === 'BROKERS' || agent.intermediaryType?.value === 'AGENTS'
                ? agent.name?.value?.value ?? 'N/A'
                : 'N/A',
        departureCountry: getSingleCountryId(quotation.departureCountry.value, countries),
        destinationCountry: getCountryId(quotation.destinationCountry.value, countries),
        travelStartDate: quotation.departureDate.value,
        travelEndDate: quotation.returnDate.value,
        noOfMinors: Number(quotation.noOfMinors?.value) || 0,
        agentType: agent.intermediaryType?.value || '',
        adults18to69: Number(quotation.adults18to69?.value) || 0,
        adults70to75: Number(quotation.adults70to75?.value) || 0,
        adults76to80: Number(quotation.adults76to80?.value) || 0,
        adults81to85: Number(quotation.adults81to85?.value) || 0,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ug/submit/quote';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
